
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ExerciseTypeField": [
      "ExerciseTypeField_Number",
      "ExerciseTypeField_Option",
      "ExerciseTypeField_String"
    ],
    "Node": [
      "Account",
      "Address",
      "Appointment",
      "BloodSugar",
      "BodyComposition",
      "BodyMeasurement",
      "Certification",
      "Chat",
      "Client",
      "Coach",
      "CoachProfile",
      "Device",
      "DietaryHistory",
      "Drug",
      "Education",
      "Exercise",
      "ExerciseComment",
      "ExerciseField",
      "ExerciseType",
      "Food",
      "FoodNutrient",
      "FoodPortion",
      "Form",
      "FormElement",
      "Goal",
      "Ingredient",
      "Interval",
      "JournalGoal",
      "Lifestyle",
      "Meal",
      "MealComment",
      "MealFood",
      "MealPlan",
      "MealPlanFeedback",
      "MealPlanTemplate",
      "MedicalHistory",
      "Message",
      "NoMealComment",
      "Note",
      "Notification",
      "NpsFeedback",
      "OrderHistory",
      "Other",
      "PlannedMeal",
      "PlannedMealItem",
      "PregnancyHistory",
      "Profile",
      "Program",
      "Recipe",
      "Rule",
      "SearchAppointmentDocument",
      "SentForm",
      "Setting",
      "ShoppingList",
      "ShoppingListItem",
      "Streak",
      "StreakDate",
      "Training",
      "WaterIntake",
      "WorkSchedule"
    ],
    "Notifiable": [
      "Appointment",
      "BloodSugar",
      "BodyComposition",
      "BodyMeasurement",
      "Client",
      "ClientModule",
      "DietaryHistory",
      "Exercise",
      "JournalGoal",
      "Meal",
      "SentForm",
      "WaterIntake"
    ],
    "Searchable": [
      "Account",
      "Appointment",
      "Profile"
    ],
    "SubscriptionPayload": [
      "MessageReadPayload",
      "MessageSentPayload",
      "MessageUpdatedPayload",
      "SynchronizePayload"
    ],
    "User": [
      "Client",
      "Coach"
    ]
  }
};
      export default result;
    